import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { SettingManagementState } from './types';

export const initialState: SettingManagementState = {
  loading: false,
  error: ''
};

const settingsSlice = createSlice({
  name: 'settingsManagement',
  initialState,
  reducers: {
    updateCompanyInformation: (state, action) => {
      state.loading = true;
    },
    updateCompanyInformationSuccess: (state, action) => {
      state.loading = false;
    },
    updateCompanyInformationFailure: (state, action) => {
      state.loading = false;
    },
    updateProfileInformation: (state, action) => {
      state.loading = true;
    },
    updateProfileInformationSuccess: (state, action) => {
      state.loading = false;
    },
    updateProfileInformationFailure: (state, action) => {
      state.loading = false;
    },
    completeProfile: (state, action) => {
      state.loading = true;
    },
    completeProfileSuccess: state => {
      state.loading = false;
    },
    completeProfileFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    inviteAccount: (state, action) => {
      state.loading = true;
    },
    inviteAccountSuccess: state => {
      state.loading = false;
    },
    inviteAccountFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    resetState: () => {
      return initialState;
    }
  }
});

export const {
  updateCompanyInformation,
  updateCompanyInformationSuccess,
  updateCompanyInformationFailure,
  updateProfileInformation,
  updateProfileInformationSuccess,
  updateProfileInformationFailure,
  completeProfile,
  completeProfileSuccess,
  completeProfileFailure,
  inviteAccount,
  inviteAccountSuccess,
  inviteAccountFailure,
  resetState
} = settingsSlice.actions;

export default settingsSlice.reducer;
